/**
 * EntitlementUpsell (ADR 042)
 *
 * Default render for a `locked` entitlement verdict — a minimal, dependency-free
 * upsell placeholder. Callers that want a richer plan-picker CTA pass their own
 * node via `<Entitled fallback={...}>` instead.
 */
export interface EntitlementUpsellProps {
  /** The gated feature key (diagnostic / analytics hook). */
  feature?: string
  /** Human label for the gated surface, when known. */
  label?: string
}

export function EntitlementUpsell({ feature, label }: EntitlementUpsellProps) {
  return (
    <div
      className="entitlement-upsell"
      role="note"
      data-testid="entitlement-upsell"
      data-feature={feature}
    >
      <p className="entitlement-upsell-text">
        {label ? `${label} isn’t` : 'This feature isn’t'} included in your current
        plan. Upgrade to unlock it.
      </p>
    </div>
  )
}
